import styled from '@emotion/styled'

export const CenteringDiv = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  height: 100%;
`
